<section class="app-dialog tarea-dialog" [class.tarea-dialog--detalle]="!esAlta">
  <header class="app-dialog__header">
    <div class="app-dialog__heading">
      <span class="tarea-dialog__icono" aria-hidden="true">
        <span class="material-icons">{{ esAlta ? "add_task" : "task_alt" }}</span>
      </span>
      <div class="tarea-dialog__titulos">
        <ng-container *ngIf="esAlta; else encabezadoDetalle">
          <p class="app-dialog__eyebrow">Tarea diaria</p>
          <h2 [id]="idTitulo">Registrar tarea</h2>
          <p>Elige uno de tus proyectos activos y describe lo que vas a hacer.</p>
        </ng-container>
        <ng-template #encabezadoDetalle>
          <p class="app-dialog__eyebrow">
            Tarea diaria<ng-container *ngIf="nombreProyecto"> · {{ nombreProyecto }}</ng-container>
          </p>
          <h2 [id]="idTitulo">{{ tarea?.nombre || "Tarea sin nombre" }}</h2>
          <p class="tarea-dialog__subtitulo">
            <span class="table-page__status-badge" [ngClass]="estatusClase">{{ tarea?.estatus || "SIN ESTATUS" }}</span>
            <span *ngIf="tarea?.fecha_creacion">Creada el {{ tarea?.fecha_creacion | date: "dd/MM/yyyy" }}</span>
          </p>
        </ng-template>
      </div>
    </div>
    <button type="button" class="app-dialog__close tarea-dialog__cerrar" aria-label="Cerrar" [disabled]="guardando"
            (click)="cancelar()">
      <span class="material-icons" aria-hidden="true">close</span>
    </button>
  </header>

  <!-- ============================ Registrar tarea ============================ -->
  <div mat-dialog-content class="app-dialog__content" *ngIf="esAlta; else contenidoDetalle">
    <div class="tarea-dialog__rejilla">
      <form class="tarea-dialog__grupo" [formGroup]="formulario" aria-labelledby="tarea-dialogo-datos">
        <h3 class="tarea-dialog__grupo-titulo" id="tarea-dialogo-datos">Datos de la tarea</h3>

        <output class="tarea-dialog__aviso" *ngIf="estadoProyectos === 'listo' && proyectos.length === 0">
          <span class="material-icons" aria-hidden="true">info</span>
          <p>{{ mensajeSinProyectos }}</p>
        </output>
        <div class="tarea-dialog__aviso is-error" *ngIf="estadoProyectos === 'error'" role="alert">
          <span class="material-icons" aria-hidden="true">error_outline</span>
          <p>No se pudieron cargar tus proyectos.</p>
          <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact"
                  (click)="cargaProyectos()">
            Reintentar
          </button>
        </div>

        <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
          <mat-label>Proyecto</mat-label>
          <span matPrefix class="material-icons tarea-dialog__prefijo" aria-hidden="true">folder_open</span>
          <input matInput [id]="idProyecto" formControlName="proyecto" [matAutocomplete]="autoProyecto"
                 autocomplete="off" (input)="alEscribirProyecto($any($event.target).value)"
                 [placeholder]="estadoProyectos === 'cargando' ? 'Cargando tus proyectos…' : 'Busca por nombre, clave o cliente'" />
          <mat-autocomplete #autoProyecto="matAutocomplete" [displayWith]="muestraProyecto" requireSelection
                            autoActiveFirstOption>
            <mat-option *ngFor="let p of proyectosFiltrados; trackBy: trackProyecto" [value]="p"
                        class="tarea-dialog__opcion">
              <span class="tarea-dialog__opcion-nombre">{{ p.nombre }}</span>
              <span class="tarea-dialog__opcion-detalle" *ngIf="p.detalle || p.vencido || p.idProyectoAzure">
                <span *ngIf="p.detalle">{{ p.detalle }}</span>
                <span class="table-page__status-badge is-pending tarea-dialog__insignia" *ngIf="p.vencido">Vencido</span>
                <span class="tarea-dialog__insignia tarea-dialog__insignia--azure" *ngIf="p.idProyectoAzure">Azure DevOps</span>
              </span>
            </mat-option>
            <mat-option *ngIf="proyectos.length > 0 && proyectosFiltrados.length === 0" disabled>
              Ningún proyecto coincide con lo que escribiste.
            </mat-option>
          </mat-autocomplete>
          <mat-hint [class.is-aviso]="proyectoSeleccionado?.vencido">{{ ayudaProyecto }}</mat-hint>
          <mat-error>Elige un proyecto de la lista; escribir el nombre no basta.</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
          <mat-label>Nombre de tarea</mat-label>
          <input matInput aria-label="Nombre de tarea" formControlName="nombre" [matAutocomplete]="autoTareas"
                 [maxlength]="largoNombre" autocomplete="off" placeholder="Escribe o elige una tarea" />
          <mat-autocomplete #autoTareas="matAutocomplete">
            <mat-option *ngFor="let t of tareasAzureFiltradas" [value]="t">{{ t }}</mat-option>
          </mat-autocomplete>
          <mat-hint [class.is-aviso]="estadoTareasAzure === 'error'">{{ ayudaNombre }}</mat-hint>
          <mat-hint align="end">{{ formulario.controls.nombre.value.length }}/{{ largoNombre }}</mat-hint>
          <mat-error *ngIf="formulario.controls.nombre.hasError('maxlength')">
            Máximo {{ largoNombre }} caracteres: acórtalo.
          </mat-error>
          <mat-error *ngIf="!formulario.controls.nombre.hasError('maxlength')">Escribe el nombre de la tarea.</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
          <mat-label>Descripción</mat-label>
          <textarea matInput aria-label="Descripción" formControlName="descripcion" rows="5"
                    [maxlength]="largoDescripcion"></textarea>
          <mat-hint>Lo que vas a hacer o el resultado esperado.</mat-hint>
          <mat-hint align="end">{{ formulario.controls.descripcion.value.length }}/{{ largoDescripcion }}</mat-hint>
          <mat-error>Describe la tarea.</mat-error>
        </mat-form-field>
      </form>

      <ng-container *ngTemplateOutlet="panelEvidencias"></ng-container>
    </div>
  </div>

  <!-- ============================ Detalle ============================ -->
  <ng-template #contenidoDetalle>
    <div mat-dialog-content class="app-dialog__content tarea-dialog__detalle">
      <dl class="tarea-dialog__datos">
        <div>
          <dt>Proyecto</dt>
          <dd>
            <ng-container *ngIf="nombreProyecto; else sinNombreProyecto">{{ nombreProyecto }}</ng-container>
            <ng-template #sinNombreProyecto>
              <span class="tarea-dialog__apagado">
                {{ proyectoSinNombre }}
              </span>
            </ng-template>
          </dd>
        </div>
        <div>
          <dt>Creación</dt>
          <dd>{{ (tarea?.fecha_creacion | date: "dd/MM/yyyy") || "—" }}</dd>
        </div>
        <div *ngIf="tarea?.estatus !== 'CREADO'">
          <dt>Inicio</dt>
          <dd>{{ (tarea?.fecha_inicio | date: "dd/MM/yyyy") || "—" }}</dd>
        </div>
        <div *ngIf="tarea?.estatus !== 'CREADO'">
          <dt>Fin</dt>
          <dd>{{ (tarea?.fecha_fin | date: "dd/MM/yyyy") || "—" }}</dd>
        </div>
        <div>
          <dt>Tiempo invertido</dt>
          <dd class="tarea-dialog__numero">{{ tiempoInvertido || "00:00:00" }}</dd>
        </div>
      </dl>

      <section class="tarea-dialog__bloque" aria-labelledby="tarea-dialogo-descripcion">
        <h3 class="tarea-dialog__grupo-titulo" id="tarea-dialogo-descripcion">Descripción</h3>
        <p class="tarea-dialog__descripcion">{{ tarea?.descripcion || "Sin descripción." }}</p>
      </section>

      <section class="tarea-dialog__bloque" aria-labelledby="tarea-dialogo-historial">
        <h3 class="tarea-dialog__grupo-titulo" id="tarea-dialogo-historial">
          Historial
          <span class="tarea-dialog__conteo" *ngIf="estadoHistorial === 'listo' && historial.length > 0">
            {{ historial.length }} {{ historial.length === 1 ? "registro" : "registros" }}
          </span>
        </h3>

        <div class="tarea-dialog__tabla" [ngSwitch]="estadoHistorial">
          <output class="table-page__empty-state" *ngSwitchCase="'cargando'">
            <span class="material-icons" aria-hidden="true">hourglass_empty</span>
            <p>Cargando el historial…</p>
          </output>
          <div class="table-page__empty-state" *ngSwitchCase="'error'" role="alert">
            <span class="material-icons" aria-hidden="true">error_outline</span>
            <p>No se pudo cargar el historial.</p>
            <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact"
                    (click)="cargaHistorial()">
              Reintentar
            </button>
          </div>
          <ng-container *ngSwitchDefault>
            <div class="table-page__empty-state" *ngIf="historial.length === 0; else tablaHistorial">
              <span class="material-icons" aria-hidden="true">pending_actions</span>
              <p>Todavía no hay tiempo registrado en esta tarea.</p>
            </div>
            <ng-template #tablaHistorial>
              <div class="table-page__table-wrap">
                <table class="table-page__table tarea-dialog__historial">
                  <thead>
                    <tr>
                      <th scope="col">Fecha de trabajo</th>
                      <th scope="col">Hora inicio</th>
                      <th scope="col">Hora fin</th>
                      <th scope="col">Tiempo invertido</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let fila of historial | paginate: { id: 'historialTarea', itemsPerPage: registrosHistorial, currentPage: paginaHistorial }">
                      <td>{{ fila.inicio | date: "dd/MM/yyyy" }}</td>
                      <td class="tarea-dialog__numero">{{ fila.inicio | date: "HH:mm:ss" }}</td>
                      <td class="tarea-dialog__numero">{{ (fila.fin | date: "HH:mm:ss") || "En curso" }}</td>
                      <td class="tarea-dialog__numero">{{ fila.tiempoInvertidoStr || "—" }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="table-page__footer tarea-dialog__pie-tabla" *ngIf="historial.length > registrosHistorial">
                <div class="table-page__meta">
                  Mostrando {{ (paginaHistorial - 1) * registrosHistorial + 1 }} a {{ finHistorial }} de {{ historial.length }}
                </div>
                <div class="table-page__pager table-page__pager--ngx">
                  <pagination-controls id="historialTarea" class="my-pagination" [responsive]="true"
                                       [directionLinks]="true" [autoHide]="false" previousLabel="ANTERIOR"
                                       nextLabel="SIGUIENTE" [maxSize]="5"
                                       (pageChange)="cambiaPaginaHistorial($event)"></pagination-controls>
                </div>
              </div>
            </ng-template>
          </ng-container>
        </div>
      </section>

      <ng-container *ngTemplateOutlet="panelEvidencias"></ng-container>
    </div>
  </ng-template>

  <!-- ============================ Evidencias (alta y detalle) ============================ -->
  <ng-template #panelEvidencias>
    <section class="tarea-dialog__evidencias" aria-labelledby="tarea-dialogo-evidencias">
      <header class="tarea-dialog__evidencias-cabecera">
        <div>
          <h3 class="tarea-dialog__grupo-titulo" id="tarea-dialogo-evidencias">Evidencias</h3>
          <p class="tarea-dialog__nota">{{ textoEvidencias }}</p>
        </div>
        <!-- El input real va oculto: el botón es el que se ve y recibe el foco. -->
        <input #selectorArchivos type="file" class="tarea-dialog__selector" multiple tabindex="-1" aria-hidden="true"
               aria-label="Agregar evidencias"
               accept="image/*,video/*,audio/*,application/*,text/plain,text/csv"
               (change)="agregaEvidencias(selectorArchivos)" />
        <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact tarea-dialog__agregar"
                [disabled]="guardando" (click)="selectorArchivos.click()">
          <span class="material-icons" aria-hidden="true">attach_file</span>
          Agregar
        </button>
      </header>

      <ul class="tarea-dialog__archivos" *ngIf="evidenciasGuardadas.length > 0" aria-label="Evidencias guardadas">
        <li *ngFor="let e of evidenciasGuardadas">
          <span class="material-icons tarea-dialog__archivo-icono" aria-hidden="true">{{ iconoArchivo(e.nombreArchivo) }}</span>
          <span class="tarea-dialog__archivo-nombre" [title]="e.nombreArchivo">{{ e.nombreArchivo }}</span>
          <span class="tarea-dialog__archivo-acciones">
            <button type="button" class="table-page__action-btn" [attr.aria-label]="'Ver ' + e.nombreArchivo"
                    title="Ver" (click)="verEvidencia(e)">
              <span class="material-icons" aria-hidden="true">visibility</span>
            </button>
            <button type="button" class="table-page__action-btn" [attr.aria-label]="'Descargar ' + e.nombreArchivo"
                    title="Descargar" (click)="descargaEvidencia(e)">
              <span class="material-icons" aria-hidden="true">download</span>
            </button>
          </span>
        </li>
      </ul>

      <ul class="tarea-dialog__archivos" *ngIf="evidencias.length > 0" aria-label="Evidencias por subir">
        <li *ngFor="let archivo of evidencias; index as i" class="is-pendiente">
          <span class="material-icons tarea-dialog__archivo-icono" aria-hidden="true">{{ iconoArchivo(archivo.name) }}</span>
          <span class="tarea-dialog__archivo-nombre" [title]="archivo.name">{{ archivo.name }}</span>
          <span class="tarea-dialog__archivo-peso">{{ tamanoArchivo(archivo.size) }}</span>
          <span class="tarea-dialog__archivo-acciones">
            <button type="button" class="table-page__action-btn table-page__action-btn--danger"
                    [attr.aria-label]="'Quitar ' + archivo.name" title="Quitar" [disabled]="guardando"
                    (click)="quitaEvidencia(i)">
              <span class="material-icons" aria-hidden="true">close</span>
            </button>
          </span>
        </li>
      </ul>

      <div class="table-page__empty-state tarea-dialog__sin-archivos"
           *ngIf="evidencias.length === 0 && evidenciasGuardadas.length === 0">
        <span class="material-icons" aria-hidden="true">upload_file</span>
        <p>{{ esAlta ? "Opcional: agrega capturas o documentos que respalden la tarea." : "Esta tarea no tiene evidencias." }}</p>
      </div>
    </section>
  </ng-template>

  <!-- Fuera del contenido que se desplaza, justo arriba de los botones: el error
       siempre queda a la vista. La región existe siempre (vacía no se ve) para
       que el lector de pantalla anuncie el texto cuando llega. -->
  <div class="tarea-dialog__estado">
    <p class="tarea-dialog__mensaje" [class.is-aviso]="confirmarDescarte" role="alert">{{ mensaje }}</p>
  </div>

  <footer mat-dialog-actions class="app-dialog__footer">
    <ng-container *ngIf="esAlta; else pieDetalle">
      <button type="button" class="app-form-btn app-form-btn--secondary" [disabled]="guardando" (click)="cancelar()">
        {{ tareaGuardada ? "Cerrar" : "Cancelar" }}
      </button>
      <button type="button" class="app-form-btn app-form-btn--primary" [disabled]="!puedeGuardar"
              [attr.aria-busy]="guardando" (click)="guardar()">
        {{ guardando ? "Guardando…" : tareaGuardada ? "Reintentar evidencias" : "Guardar" }}
      </button>
    </ng-container>
    <ng-template #pieDetalle>
      <button type="button" class="app-form-btn app-form-btn--secondary" [disabled]="guardando" (click)="cancelar()">
        Cerrar
      </button>
      <button type="button" class="app-form-btn app-form-btn--primary" *ngIf="evidencias.length > 0"
              [disabled]="guardando" [attr.aria-busy]="guardando" (click)="guardaEvidencias()">
        {{ guardando ? "Subiendo…" : "Guardar evidencias" }}
      </button>
    </ng-template>
  </footer>
</section>
